import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";

import { db, serverTime } from "../Utils/firebase";

function EditCardTheme({ theme, changeTheme }) {
  const { userData, userAuth, setUserData } = useContext(AuthContext);
  const [disable, setDisable] = useState(true);
  const [btnText, setBtnText] = useState("Save");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mount, setMount] = useState(true);
  const initialTheme = theme;

  const handleChange = (e) => {
    changeTheme(e.target.value);
    setBtnText("Save");
    if (e.target.value !== userData.theme) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  };

  const handleSubmit = (e) => {
    setError(null);
    setDisable(true);
    setBtnText("Saving ...");
    e.preventDefault();
    if (initialTheme !== "") {
      setLoading(true);
      db.collection("user")
        .doc(userAuth.uid)
        .update({
          theme: initialTheme.trim().toString(),
          updateAt: serverTime,
        })
        .then(() => {
          db.collection("user")
            .doc(userAuth.uid)
            .get()
            .then((doc) => {
              setUserData(doc.data());
              if (mount) {
                setBtnText("Saved");
                setLoading(false);
              }
            })
            .catch(() => {
              if (mount) {
                setBtnText("Save");
                setError("Fail to load data!");
                setLoading(false);
              }
            });
        })
        .catch(() => {
          if (mount) {
            setBtnText("Save");
            setError("Somenthing wrong!");
            setLoading(false);
          }
        });
    }
  };

  useEffect(() => {
    return () => {
      setMount(false);
    };
  }, []);

  return (
    <div className="edit-theme divContent darktextColor darkdivColor">
      <div className="head-tab">
        <h5 className="textTitle textMedium">Theme</h5>
        <p className="text">
          {error ? (
            <span className="error">{error}</span>
          ) : (
            <span>Choose Card Theme!</span>
          )}
        </p>
      </div>
      <form className="choose-form" onSubmit={handleSubmit}>
        <div className="theme-wrap">
          <div className="radio">
            <input
              type="radio"
              name="theme"
              value="light"
              id="theme-light"
              defaultChecked={initialTheme === "light"}
              onChange={handleChange}
              disabled={loading}
            />
            <label
              htmlFor="theme-light"
              className="lighttextColor lightdivColor text textBold"
            >
              <span></span>Light
            </label>
          </div>
          <div className="radio">
            <input
              type="radio"
              name="theme"
              value="dark"
              id="theme-dark"
              defaultChecked={initialTheme === "dark"}
              onChange={handleChange}
            />
            <label
              htmlFor="theme-dark"
              className="darktextColor darkdivColor text textBold"
            >
              <span></span>Dark
            </label>
          </div>
        </div>
        <button
          className={
            disable
              ? "btn-in darktextColor textTitle disable"
              : "btn-in darktextColor textTitle "
          }
          disabled={disable}
          type="submit"
        >
          {btnText}
        </button>
      </form>
    </div>
  );
}

export default EditCardTheme;
